import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getError } from '../../../utils';
import { useTranslation } from 'react-i18next';
import faqService from '../../../services/faq.service';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogClose,
} from '../../ui/dialog';

export default function NewFaqQuestionModal({ show, handleClose, edit, editQuestion }) {
  const { t } = useTranslation();
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (edit) {
      setQuestion(editQuestion.question);
      setAnswer(editQuestion.answer);
      setActive(editQuestion.active);
    } else {
      setQuestion('');
      setAnswer('');
      setActive(false);
    }
  }, [edit, editQuestion, show]);

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      await faqService.createFaq({
        question,
        answer,
        active,
      });
      toast.success(t('faq.questionAdded'));
      handleClose();
    } catch (err) {
      toast.error(getError(err));
    }
  };

  const handleEditQuestion = async e => {
    e.preventDefault();
    try {
      const data = { question, answer, active };
      await faqService.updateFaq(editQuestion._id, data);
      toast.success(t('faq.changesSuccess'));
      handleClose();
    } catch (ex) {
      toast.error(getError(ex));
      console.error(ex);
    }
  };

  return (
    <Dialog
      open={show}
      onOpenChange={open => {
        if (!open) handleClose();
      }}
    >
      <DialogContent className='max-w-xl'>
        <DialogHeader>
          <DialogTitle>{edit ? t('faq.editQuestion') : t('faq.newQuestion')}</DialogTitle>
        </DialogHeader>

        <div className='space-y-4 py-2'>
          <div>
            <Input
              onChange={e => setQuestion(e.target.value)}
              required
              placeholder={t('faq.question')}
              value={question}
            />
          </div>
          <div>
            <textarea
              className='w-full rounded-md border border-input bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:opacity-50 resize-y'
              onChange={e => setAnswer(e.target.value)}
              value={answer}
              rows={4}
              placeholder={t('faq.answer')}
              required
            />
          </div>
          <div className='flex items-center gap-2'>
            <input
              type='checkbox'
              id='newActive'
              className='h-4 w-4 rounded border-input accent-primary'
              onChange={e => setActive(e.target.checked)}
              checked={active}
            />
            <label htmlFor='newActive' className='block text-sm font-medium text-foreground'>
              {t('faq.active')}
            </label>
          </div>
        </div>

        <DialogFooter>
          <DialogClose asChild>
            <Button variant='outline'>{t('common.cancel')}</Button>
          </DialogClose>
          <Button onClick={edit ? handleEditQuestion : handleSubmit}>{t('common.save')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
